/** Which Harper checks run beyond spelling, and how. Everything is off by default. */
export type ProofingDialect = 'American' | 'British' | 'Canadian' | 'Australian' | 'Indian'

export interface ProofingSettings {
  /** Paused with Ctrl+F8: no underlines, whatever the checks below say. */
  paused: boolean
  grammar: boolean
  punctuation: boolean
  style: boolean
  dialect: ProofingDialect
  /** Harper rule name → forced on/off. Rules not listed keep Harper's default. */
  ruleOverrides: Record<string, boolean>
}

export const PROOFING_DIALECTS: ProofingDialect[] = ['American', 'British', 'Canadian', 'Australian', 'Indian']

export const DEFAULT_PROOFING_SETTINGS: ProofingSettings = {
  paused: false,
  grammar: false,
  punctuation: false,
  style: false,
  dialect: 'American',
  ruleOverrides: {},
}

export function normalizeProofingSettings(raw: any): ProofingSettings {
  const ruleOverrides: Record<string, boolean> = {}
  if (raw?.ruleOverrides && typeof raw.ruleOverrides === 'object') {
    for (const [rule, enabled] of Object.entries(raw.ruleOverrides)) {
      if (typeof enabled === 'boolean') ruleOverrides[rule] = enabled
    }
  }
  return {
    paused: raw?.paused === true,
    grammar: raw?.grammar === true,
    punctuation: raw?.punctuation === true,
    style: raw?.style === true,
    dialect: PROOFING_DIALECTS.includes(raw?.dialect) ? raw.dialect : 'American',
    ruleOverrides,
  }
}
